import { commentItems } from '@/mocks/home';

export default function SectionComments() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-chat-3-line text-primary-500 mr-2"></i>
          观众热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentItems.slice(0, 5).map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</div>
                  <div className="text-xs text-secondary-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-secondary-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}